import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { useConfig, waLink } from "@/context/ConfigContext";
import { IMAGES } from "@/lib/api";

export default function ContactSection() {
  const config = useConfig();

  const cards = [
    { icon: Phone, label: "Phone", value: config.phone, testId: "contact-phone" },
    {
      icon: MessageCircle,
      label: "WhatsApp",
      value: "Chat with us",
      href: waLink(config),
      testId: "contact-whatsapp",
    },
    { icon: Mail, label: "Email", value: config.email, testId: "contact-email" },
    { icon: MapPin, label: "Office Address", value: config.address, testId: "contact-address" },
  ];

  return (
    <section id="contact" data-testid="contact-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="09"
          eyebrow="Reach Out"
          title="Let's Discuss Your Property Requirement"
          description="Exserviceman Property Services — Nagpur, Maharashtra, India."
        />

        <div className="mt-14 grid gap-10 lg:grid-cols-2">
          <div className="grid gap-5 sm:grid-cols-2">
            {cards.map((card, i) => (
              <Reveal key={card.label} delay={i * 0.07}>
                <div className="h-full rounded-xl border border-gray-100 bg-background p-6 transition-colors duration-300 hover:border-gold/40">
                  <card.icon className="h-6 w-6 text-gold-dark" aria-hidden="true" />
                  <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-navy/50">{card.label}</p>
                  {card.href ? (
                    <a
                      href={card.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={card.testId}
                      className="mt-1.5 block font-semibold text-navy transition-colors hover:text-gold-dark"
                    >
                      {card.value}
                    </a>
                  ) : (
                    <p data-testid={card.testId} className="mt-1.5 font-semibold text-navy">
                      {card.value}
                    </p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="relative h-full min-h-[320px] overflow-hidden rounded-xl">
              <img
                src={IMAGES.map}
                alt="Map placeholder for Exserviceman Property Services office location in Nagpur"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-navy/40" />
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-navy">
                  <MapPin className="h-6 w-6" aria-hidden="true" />
                </span>
                <p className="rounded-sm bg-navy/80 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white backdrop-blur">
                  Map placeholder &mdash; Nagpur, Maharashtra
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
